/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Seccion_Home from "./Secciones/Seccion_Home";
import Barra from "./Barra/Barra";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {useCarritoFlotante} from "../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import {useEffect} from "react";
import {irArriba} from "../Utilidades/irArriba";
import Footer from "./Footer";
import Seccion_Escuelas from "./Secciones/Seccion_Escuelas";
import Seccion_Contactos from "./Secciones/Seccion_Contactos";
import Seccion_Formacion_Detalle from "./Secciones/Seccion_Formacion_Detalle";
import Seccion_Escuela_Detalle from "./Secciones/Seccion_Escuela_Detalle";

const Pagina = () => {
    const {CarritoFlotante} = useCarritoFlotante();

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Router>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>

                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/Escuelas"} element={<Seccion_Escuelas/>}/>
                        <Route path={"/Contactos"} element={<Seccion_Contactos/>}/>
                        <Route path={"/Formacion/:id"} element={<Seccion_Formacion_Detalle/>}/>
                        <Route path={"/Escuela/:id"} element={<Seccion_Escuela_Detalle/>}/>
                        {/*}   <Route path={"/PorMayor"} element={<Seccion_PorMayor/>}/>*/}

                    </Routes>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Footer/>
                </Grid>


                <CarritoFlotante/>


            </Router>

        </Grid>
    )

}
export default Pagina